// energysafety — Vite entrypoint for the marketing landing page ("visitka").
//
// Wired into views/main_page/index.html.slim via:
//   = vite_client_tag
//   = vite_javascript_tag 'main_page'
//
// Deliberately its own tiny entrypoint rather than the gentelella-4
// `application` bundle: the landing page stays on the classic Sprockets
// pipeline (main_page.css.erb / main_page.js) for everything else, so this
// only needs to pull in Leaflet for the clients map -- not the whole admin
// design system (shell.js, application.scss, DataTables, etc).
//
// The Leaflet chunk itself (~50KB gzipped) is still not tiny, and the map
// sits well below the fold -- a static import here would have Vite emit a
// `modulepreload` hint that fetches it immediately on every visit, before
// anyone has scrolled anywhere near it. Deferring via a dynamic import()
// behind an IntersectionObserver means that weight only downloads once a
// visitor actually scrolls close to the map (rootMargin pre-fetches a
// little early so the tiles aren't visibly popping in mid-scroll).
function boot() {
  const el = document.querySelector('[data-building-map]')
  if (!el) return

  const load = () => import('../components/building_map.js').then((m) => m.initBuildingMap())

  if (!('IntersectionObserver' in window)) {
    load()
    return
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) {
      observer.disconnect()
      load()
    }
  }, { rootMargin: '400px 0px' })
  observer.observe(el)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
